import React from 'react';
import styled from 'astroturf/react';

import type { ArmSpec } from '../armRegistry';
import { openerIntent } from '../openerIntent';
import type { OpenerDetail, OpenerIntent } from '../openerIntent';

const Pill = styled.p`
  max-width: 320px;
  margin: var(--spacing-xxs-8, 8px) auto 0;
  padding: 6px 14px;
  background: var(--background-secondary, #f7f7f8);
  border-radius: var(--border-radius-radius-md, 12px);
  font-family: var(--type-font-family-sans-serif, 'DM Sans', sans-serif);
  font-size: 14px;
  line-height: 1.4;
  color: var(--text-primary, #26262b);
  text-align: center;
`;

// Clauses are promises about what happens on completion; never signup vocab.
const FINAL_CLAUSE: Record<OpenerIntent, string> = {
  download: 'your PDF opens right away',
  read: 'your PDF opens right away',
  save: 'your paper is saved right away',
  share: 'your share link is ready right away',
  cite: 'your citation is ready right away',
  follow: "you're following right away",
  message: 'you can message right away',
  signup: "you're ready right away",
  other: "you're ready right away",
};

function reassuranceText(detail: OpenerDetail): string {
  return `Free forever · No spam · ${FINAL_CLAUSE[openerIntent(detail)]}`;
}

const ReassurancePill: React.FC<{ detail: OpenerDetail }> = ({ detail }) => (
  <Pill>{reassuranceText(detail)}</Pill>
);

export const reassurancePillSpec: ArmSpec = {
  slots: (ctx) => ({ underCta: <ReassurancePill detail={ctx.detail} /> }),
};
